/** TWO COLUMN ACCORDION GROUPED COLLAPSING **/
let colOneBtns = document.querySelectorAll(".accordion-col1-btn");
let colOneBodies = document.querySelectorAll(".accordion-col1-body");

let colTwoBtns = document.querySelectorAll(".accordion-col2-btn");
let colTwoBodies = document.querySelectorAll(".accordion-col2-body");

colOneBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
        colTwoBodies.forEach((body) => {
            body.classList.remove("show");
        });
        colTwoBtns.forEach((btn) => {
            btn.classList.add("collapsed");
        });
    });
});
colTwoBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
        colOneBodies.forEach((body) => {
            body.classList.remove("show");
        });
        colOneBtns.forEach((btn) => {
            btn.classList.add("collapsed");
        });
    });
});
